// write by cursor
// 生成时间: 2025-07-29 19:45:14
// 简化的错误处理器 - 只保留必要的处理逻辑

import { message } from 'antd';
import { ErrorHandler, ApiRequestConfig } from '../types/request';
import { gsT } from '../i18n';

/**
 * 创建自定义错误处理器 - write by cursor
 */
export const createCustomErrorHandler = (): ErrorHandler => {
  return async (error: any, config?: ApiRequestConfig) => {
    if (config?.customErrorHandler) {
      return await config.customErrorHandler(error, config);
    }
    return false;
  };
};

/**
 * 创建业务错误处理器 - write by cursor
 * 强制使用 errorCodeMap，不允许显示原始错误信息
 */
export const createBusinessErrorHandler = (errorCodeMap: Record<number, string> = {}): ErrorHandler => {
  return (error: any) => {
    // 检查是否为业务错误 (response.data.code !== 0)
    if (error.businessError && error.code) {
      // 强制使用错误码映射，如果没有映射则使用通用消息
      const errorMessage = errorCodeMap[error.code] || gsT('request_failed');
      message.error(errorMessage);
      return true;
    }
    return false;
  };
};

/**
 * 创建HTTP状态码错误处理器 - write by cursor
 * 统一HTTP错误消息，不显示具体状态码
 */
export const createHttpStatusErrorHandler = (): ErrorHandler => {
  return (error: any) => {
    const status = error.response?.status;
    if (!status || status < 400) return false;
    
    let errorMessage = gsT('service_unavailable');
    switch (status) {
      case 401:
        // 401由Token管理器处理，这里不处理
        return false;
      case 403:
        errorMessage = gsT('permission_denied');
        break;
      case 404:
        errorMessage = gsT('resource_not_found');
        break;
      case 429:
        errorMessage = gsT('rate_limit_exceeded');
        break;
      case 500:
      case 502:
      case 503:
        errorMessage = gsT('service_unavailable');
        break;
    }
    
    message.error(errorMessage);
    return true;
  };
}; 